import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface User {
    id: string;
    email: string;
    full_name: string;
    tenant_id?: string;
    roles?: string[];
}

interface AuthStore {
    user: User | null;
    token: string | null;
    isAuthenticated: boolean;
    login: (token: string, user: User) => void;
    logout: () => void;
}

export const useAuthStore = create<AuthStore>()(
    persist(
        (set) => ({
            user: null,
            token: null,
            isAuthenticated: false,
            login: (token, user) => set({ token, user, isAuthenticated: true }),
            logout: () => {
                localStorage.removeItem('auth_token');
                localStorage.removeItem('user');
                set({ token: null, user: null, isAuthenticated: false });
            },
        }),
        { name: 'auth-storage' }
    )
);
